import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { asArray, dbObjectToId, exists } from '@nu-art/ts-common';
import { FrameLayout } from '../FrameLayout/index.js';
import { LL_H_C, LL_H_T, LL_V_L } from '../Layouts/index.js';
import './Page_ItemsEditor.scss';
import { ItemEditor_DefaultList } from './defaults/ItemEditor_ListRenderer/index.js';
import { ItemEditor_DefaultFilter } from './defaults/ItemEditor_DefaultFilter/index.js';
import { TS_Icons } from '@nu-art/ts-styles';
import { ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, openContent } from '../../component-modules/mouse-interactivity/index.js';
import { TS_ButtonLoader } from '../TS_ButtonLoader/index.js';
import { _className } from '../../utils/tools.js';
import { ProtoComponent } from '../../core/proto-component/index.js';
import { ModuleFE_BrowserHistoryV2 } from '../../modules/ModuleFE_BrowserHistoryV2.js';
import { EditableDBItemV3 } from '../../utils/EditableItem.js';
export class Page_ItemsEditor extends ProtoComponent {
    static _defaultProps = {
        keys: ['selected'],
    };
    constructor(p) {
        super(p);
    }
    componentDidMount() {
        const selectedId = this.getQueryParam('selected', {})[this.props.module.dbDef.dbKey];
        if (!selectedId)
            this.onSelected(this.props.sort(this.props.module.cache.allMutable())[0]);
    }
    deriveStateFromProps(nextProps, state) {
        if (nextProps === this.props || nextProps.module !== this.props.module) {
            // @ts-ignore
            delete this[this.props.module.defaultDispatcher.method];
            // @ts-ignore
            this[nextProps.module.defaultDispatcher.method] = (...args) => this.__onItemUpdated(...args);
        }
        const selectedId = this.getQueryParam('selected', {})[this.props.module.dbDef.dbKey];
        if (!exists(selectedId)) {
            state.editable = this.createEditableItem({});
            this.props.onSelectedItemChanged?.(state.editable);
            return state;
        }
        const item = this.props.module.cache.unique(selectedId);
        if (!exists(item)) {
            this.logError(`Could not find item ${this.props.module.dbDef.dbKey} with id ${selectedId}`);
            this.onSelected();
            this.props.onSelectedItemChanged?.();
            return state;
        }
        state.editable = this.createEditableItem(item);
        this.props.onSelectedItemChanged?.(state.editable);
        state.filter ??= () => true;
        return state;
    }
    __onItemUpdated = (...params) => {
        const items = asArray(params[1]);
        if (!items.map(dbObjectToId).includes(this.state.editable.get('_id')))
            return this.onSelected(items[0]);
        if (params[0] === 'delete' || params[0] === 'delete-multi')
            return this.onSelected();
        return this.reDeriveState();
    };
    createEditableItem(item) {
        return new EditableDBItemV3({ ...item }, this.props.module)
            .setOnSaveCompleted(this.onSelected.bind(this))
            .setAutoSave(true);
    }
    render() {
        const List = this.props.ListRenderer || ItemEditor_DefaultList;
        const Filter = this.props.Filter || ItemEditor_DefaultFilter;
        const Editor = this.props.EditorRenderer;
        const sort = this.props.sort;
        const selectedItem = this.state.editable?.item;
        return _jsx(FrameLayout, { id: this.props.id, className: "editor-page", children: _jsxs(LL_H_T, { className: _className(this.props.className ?? 'editor-content', 'match_parent'), children: [_jsxs(LL_V_L, { className: "items-editor__list", children: [_jsxs(LL_V_L, { className: 'items-editor__list-header-content', children: [_jsx("div", { className: 'items-editor__list-header', children: this.renderHeader() }), _jsx(Filter, { onFilterChanged: filter => this.setState({ filter }), mapper: this.props.mapper }), this.renderMenuIcon()] }), _jsx(List, { contextMenuItems: this.props.contextMenuActions, itemRenderer: this.props.itemRenderer, filter: this.state.filter, selected: selectedItem, sort: sort, module: this.props.module, onSelected: this.onSelected.bind(this) }), this.renderAddNewItem()] }), _jsx("div", { className: "item-editor", children: _jsx(Editor, { item: selectedItem }) })] }) });
    }
    renderHeader() {
        return '';
    }
    renderAddNewItem() {
        if (this.props.hideAddItem)
            return '';
        return _jsx(Component_AddNewItem, { entity: this.renderHeader(), onCreateNewItem: async () => this.onSelected({}) });
    }
    static refactoring_setSelected(module, id) {
        const selected = (ModuleFE_BrowserHistoryV2.get('selected') ?? {});
        const selectedId = id;
        if (!selectedId)
            delete selected[module.dbDef.dbKey];
        else
            selected[module.dbDef.dbKey] = selectedId;
        ModuleFE_BrowserHistoryV2.set('selected', selected);
    }
    onSelected(item) {
        Page_ItemsEditor.refactoring_setSelected(this.props.module, item?._id);
        // const selected = this.getQueryParam('selected', {} as CProto['queryParamDef']['selected']);
        //
        // const selectedId = item?._id;
        // if (!selectedId)
        // 	delete selected[this.props.module.dbDef.dbKey];
        // else
        // 	selected[this.props.module.dbDef.dbKey] = selectedId;
        //
        // this.setQueryParam('selected', selected);
        this.reDeriveState();
    }
    renderMenuIcon = () => {
        if (!this.props.actions)
            return;
        return _jsx(TS_Icons.more.component, { className: 'editor--menu-icon', ...openContent.popUp.bottom('editor--menu', this.renderMenu, 10) });
    };
    renderMenu = (refreshPopup) => {
        return _jsx(_Fragment, { children: this.props.actions.map((action, index) => {
                const actionInProgress = this.state.actionInProgress;
                if (actionInProgress === index)
                    return _jsx("div", { className: 'editor--loader-wrapper', children: _jsx(TS_ButtonLoader, {}) }, action.label);
                const className = _className('editor--menu-action', exists(actionInProgress) && 'disabled');
                return _jsx("div", { className: className, onClick: async () => {
                        if (exists(this.state.actionInProgress))
                            return;
                        this.setState({ actionInProgress: index }, async () => {
                            refreshPopup();
                            try {
                                await action.action(this.state);
                                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                            }
                            catch (err) {
                                this.logError(err);
                                this.setState({ actionInProgress: undefined }, () => refreshPopup());
                            }
                        });
                    }, children: action.label }, action.label);
            }) });
    };
}
export const Component_AddNewItem = (props) => {
    return _jsxs(LL_H_C, { className: "add-item-v3 clickable", onClick: props.onCreateNewItem, children: ["Add new ", props.entity] });
};
//# sourceMappingURL=Page_ItemsEditor.js.map